$(document).ready(function () {
  // Find the first .shopify-section that contains the contact form
  var $formSection = null;

  $('.shopify-section').each(function () {
    if ($(this).find('form#ContactForm').length > 0) {
      $formSection = $(this);
      return false; // exit loop after first match
    }
  });

  $('.header_btn a').on('click', function (e) {
    e.preventDefault();

    if ($formSection) {
      // If form section is found, scroll to it
      console.log("yes found");
      console.log($formSection);

      $('html, body').animate({
        scrollTop: $formSection.offset().top
      }, 800); // 800ms smooth scroll
    } else {
      // If not found, redirect to homepage
      window.location.href = '/';
    }
  });
});

$(document).ready(function () {
  // Hide all submenus initially
  $('.submenu-child').hide();

  // Toggle submenu on clicking caret
  $('.toggle-submenu').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling if inside a div

    const $toggle = $(this);
    const $parentLi = $toggle.closest('li');
    const $submenu = $parentLi.children('ul.submenu-child');

    const isOpen = $submenu.is(':visible');

    // Close sibling submenus at the same level
    $parentLi.siblings('li').each(function () {
      $(this).find('ul.submenu-child:visible').slideUp(300);
      $(this).find('.toggle-submenu.active').removeClass('active').html(getOpenIcon());
    });

    if (isOpen) {
      // Close submenu
      $submenu.slideUp(300);
      $toggle.removeClass('active').html(getOpenIcon());
    } else {
      // Open submenu
      $submenu.slideDown(300);
      $toggle.addClass('active').html(getCloseIcon());
    }
  });

  // Prevent link clicks from toggling submenu
  $('.menu-link-wrapper .menu-link').on('click', function (e) {
    // Allow default navigation
    e.stopPropagation(); // Prevent parent div click from firing
  });

  // SVG icons
  function getOpenIcon() {
    return `<svg class="icon icon-caret open-icon" viewBox="0 0 10 6">
      <path fill="currentColor" fill-rule="evenodd"
        d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
        clip-rule="evenodd"></path>
    </svg>`;
  }

  function getCloseIcon() {
    return `<svg class="icon icon-caret close-icon" viewBox="0 0 10 6" style="transform: rotate(180deg);">
      <path fill="currentColor" fill-rule="evenodd"
        d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
        clip-rule="evenodd"></path>
    </svg>`;
  }
});
